import { type FC, type ReactNode, type ChangeEvent } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { Input } from 'dibs-elements/exports/Input';

type Props = {
    isLoading?: boolean;
    value: string;
    errorMessage?: ReactNode;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const messages = defineMessages({
    lastName: { id: 'DealerApplicationForm.lastName.placeHolder', defaultMessage: 'Last Name' },
});

const LastName: FC<Props> = ({ isLoading, value, onChange, errorMessage }) => {
    const intl = useIntl();
    return (
        <Input
            dataTn="last-name-contact"
            name="last-name-contact"
            placeholder={intl.formatMessage(messages.lastName)}
            hasAnimatedPlaceholder
            autoComplete="family-name"
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={isLoading}
            value={value}
        />
    );
};

export default LastName;
